<section class="footer section">
    <hr>
    <div class="footer__stamp">
        <img src="assets/img/view/stamp_37.png" alt="Selo 37 anos" class="footer__stamp-image">
    </div>
    <div class="columns footer__items">
        <div class="column footer__items-seal">
            <img *ngFor="let seal of seals" [src]="seal.img" [alt]="seal.alt" [class]="seal.class">
        </div>
        <div class="column footer__items-address">
            <p class="footer__items-address__text">
                MONTREAL - 123123123IAGENS E TURISMO S.A.
                CNPJ 02.703.809/0001-05.
                <br/>
                SMAS, Área 6580, Trecho 1,ParkShopping
                Corporate Torre 1, 3° andar. Guará, Brasília – DF,
                CEP 71219-900
            </p>
        </div>
        <div class="column footer__items-app">
          <h4>Baixe12312312ivo da Montreal</h4>
          <p>Acompanhe, gerencie suas diárias e aproveite os <br> benefícios da Montreal Viagens direto no seu celular.</p>
          <div class="columns is-centered is-gapless footer__items-app__links">
            <a target="_blank" [href]="app.href" [class]="'column footer__items-app__links-'+app.icon" *ngFor="let app of apps">
                <app-svg-icon [icon]="app.icon"></app-svg-icon>
            </a>
          </div>
        </div>
        <div class="column footer__items-social">
            <div class="footer__items-social__logo">
                <app-svg-icon [flex]="true"
                              [width]="logoSizeWidth"
                              [height]="logoSizeHeight"
                              icon="logo-montreal-novo"
                              fill="#EB2037">
                </app-svg-icon>
            </div>
            <div class="footer__items-social__apps">
                <div class="columns is-centered is-gapless footer__items-social__apps-list">
                    <a [class]="'column footer__items-social__apps-list__'+social.id"
                       *ngFor="let social of socials"
                       [title]="social.title"
                       [href]="social.href"
                       target="_blank">
                        <app-svg-icon class="footer__items-social__apps-list__icon"
                                      [icon]="social.icon"
                                      [flex]="true"
                                      [width]="socialSizeWidth"
                                      [height]="socialSizeHeight"
                        ></app-svg-icon>
                    </a>
                </div>
            </div>
        </div>
        <div class="column footer__items-button">
<!--            <hr>-->
<!--            <div class="buttons">-->
<!--                <a class="button is-primary" (click)="goToCart()">-->
<!--                    <strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Assine agora&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>-->
<!--                </a>-->
<!--            </div>-->
        </div>
    </div>
</section>
